module.exports = __webpack_public_path__ + "static/Hardish-Wilkhu--7bf1c4f67e1c158b80bb430b73caa5f9.jpg";